export const API_PATH_ApiDeviceMgmtRegionChangeId = '/services/devices-mgtm/apiDeviceMgmtRegionChangeId';
